import { GraphQLError } from "graphql";

import { GraphQLAPI } from "./client";

export * as bank from "./operations/bank";
export * as file from "./operations/file";
export * as fragments from "./fragments";
export * as issue from "./operations/issue";
export * as operations from "./operations";
export * as queries from "./queries";

export * from "./client";
export * from "./types";

export default GraphQLAPI;

export const hasGraphQLErrors = (e: unknown): e is { errors: GraphQLError[] } =>
  e != null &&
  typeof e === "object" &&
  "errors" in e &&
  Array.isArray(e.errors);
